import { useLocation } from "react-router";
import { useMemo } from "react";

const core = {
    // Returns a plain object, because every call site reads it with property
    // access (`query.page`). It used to hand back a URLSearchParams, on which
    // those properties are always undefined — so no page ever restored its
    // filters from the URL.
    useQuery() {
        const { search } = useLocation();
        return useMemo(() => Object.fromEntries(new URLSearchParams(search)), [search]);
    },
    formdatDate(d, f) {
        const date = new Date(d);
        if (Number.isNaN(date.getTime())) return "";
        const format = f.toLowerCase();
        const pad = (n) => String(n).padStart(2, "0");
        return format
            .replace("yyyy", date.getFullYear())
            .replace("mm", pad(date.getMonth() + 1))
            .replace("dd", pad(date.getDate()))
            .replace("hr", pad(date.getHours()))
            .replace("min", pad(date.getMinutes()))
            .replace("sec", pad(date.getSeconds()));
    },
}

export default core;
